// extracted by mini-css-extract-plugin
export default {"sameLine":"basicCard_sameLine__Qc7Us","topMargin":"basicCard_topMargin__pMrLk","button":"basicCard_button__4D4NH","noTopMargin":"basicCard_noTopMargin__HvwE2"};